import {isValidElement, ReactNode} from 'react'

export function isReactNode(arg: any): arg is ReactNode {
  return (
    isValidElement(arg) ||
    typeof arg === 'string' ||
    typeof arg === 'number' ||
    typeof arg === 'boolean' ||
    arg === undefined ||
    arg === null
  )
}
